<template>
  <div
    class="live-data-page"
    :class="{
      'electron-live-data-page': isElectron,
      'app-live-data-page': isHXApp,
    }"
  >
    <div v-if="!isHXApp" class="page-header">
      <button @click="$router.push('/')" class="back-btn" v-preventReClick>
        <img src="../../assets/images/arrow-left.png" alt="" />
        返回首页
      </button>
      <span>直播数据</span>
    </div>
    <div class="bg-img-wrap">
      <img
        class="bg-img-bg"
        v-if="liveReport.org_bg_pic"
        :src="orgBgPic + '|imageMogr2/blur/50x50'"
        alt=""
      />
      <img class="bg-img" :src="orgBgPic" alt="背景图" />
    </div>
    <div v-if="showPageCont" class="page-cont">
      <div class="lesson-info-wrap">
        <div class="left-wrap">
          <p class="lesson-name">{{ liveReport.lesson_name }}</p>
          <p class="time-wrap">
            <span class="time"
              >{{
                moment(liveReport.room_start_time * 1000).format(
                  "YYYY-MM-DD HH:mm"
                )
              }}-{{
                moment(liveReport.room_end_time * 1000).format(" HH:mm")
              }}</span
            >
            <span class="duration">{{ handleLiveDuration }}</span>
          </p>
        </div>
        <button v-if="!isHXApp" @click="jumpCourseDetail" class="operate-btn">
          查看课程回放
        </button>
      </div>
      <div class="live-heat">
        <img src="../../assets/images/live-data/live-heat-title.png" alt="" />
        <ul
          class="data-wrap"
          :class="{ 'small-course-data-wrap': liveReport.course_type === 2 }"
        >
          <li class="data-item" style="width: 202px">
            <div>
              <p class="data">{{ liveReport.live_num }}</p>
              <p class="data-name">直播参与人数</p>
            </div>
          </li>
          <li class="data-item center" style="width: 258px">
            <div>
              <p class="data">{{ liveReport.live_peak_num }}</p>
              <p class="data-name">直播峰值人数</p>
            </div>
          </li>
          <!-- 小班课不显示此项数据 -->
          <li v-if="liveReport.course_type === 1" class="data-item">
            <p class="data">{{ liveReport.live_mic_num }}</p>
            <p class="data-name">直播连麦次数</p>
          </li>
        </ul>
      </div>
      <div class="echarts-wrap">
        <p class="title">直播参与人数走势图</p>
        <div id="viewers-num-echarts"></div>
      </div>
      <div class="live-income">
        <img src="../../assets/images/live-data/income-title.png" alt="" />
        <p v-if="liveReport.sell_course_duration === 0" class="tips">
          在直播中使用课程售卖功能后可产生直播收益
        </p>
        <div v-else>
          <ul class="data-wrap">
            <li class="data-item" style="width: 202px">
              <p class="data">{{ liveReport.sell_course_num }}</p>
              <p class="data-name">上架课程数量</p>
            </li>
            <li class="data-item center" style="width: 258px">
              <div>
                <p class="data duration-time">
                  {{ handleSellDuration }}
                </p>
                <p class="data-name">课程上架时长</p>
              </div>
            </li>
            <li class="data-item">
              <p class="data">{{ liveReport.sell_course_click_num }}</p>
              <p class="data-name">链接点击次数</p>
            </li>
          </ul>
          <ul class="data-wrap sell-data-wrap">
            <li class="data-item" style="width: 202px">
              <p class="data course-name">
                {{ liveReport.sell_max_earnings_goods_name || "无" }}
              </p>
              <p class="data-name">收益最高商品</p>
            </li>
            <li class="data-item center" style="width: 258px">
              <div>
                <p class="data course-name">
                  {{ liveReport.sell_max_goods_name || "无" }}
                </p>
                <p class="data-name">售出最多商品</p>
              </div>
            </li>
            <li class="data-item">
              <p class="data sell-amount" v-html="handleSellTotalAmount"></p>
              <p class="data-name">本场直播收入</p>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { isHXApp } from "@saas/components/src";
import moment from "moment";
import {
  getDurationByStartEndTime,
  handleImageUrl,
} from "@saas/components/src/utils/utils";
import { getLiveReport } from "@saas/service-api/src/course";
// 引入 echarts 核心模块，核心模块提供了 echarts 使用必须要的接口。
import * as echarts from "echarts/core";
// 引入柱状图图表，图表后缀都为 Chart
import { LineChart } from "echarts/charts";
// 引入标题，提示框，直角坐标系，数据集，内置数据转换器组件，组件后缀都为 Component
import {
  TitleComponent,
  TooltipComponent,
  GridComponent,
  DatasetComponent,
  TransformComponent,
} from "echarts/components";
// 标签自动布局、全局过渡动画等特性
import { LabelLayout, UniversalTransition } from "echarts/features";
// 引入 Canvas 渲染器，注意引入 CanvasRenderer 或者 SVGRenderer 是必须的一步
import { CanvasRenderer } from "echarts/renderers";

// 注册必须的组件
echarts.use([
  TitleComponent,
  TooltipComponent,
  GridComponent,
  DatasetComponent,
  TransformComponent,
  LabelLayout,
  UniversalTransition,
  CanvasRenderer,
  LineChart,
]);

export default {
  data: function () {
    return {
      liveReport: {},
      moment,
      showPageCont: true,
      isElectron: window.isElectron,
      isHXApp: false,
    };
  },
  mounted() {
    this.isHXApp = isHXApp();
    this.apiGetLiveReport();
    this.initEcharts();
  },
  computed: {
    orgBgPic() {
      if (this.liveReport?.org_bg_pic) {
        return (
          handleImageUrl(this.liveReport?.org_bg_pic) + "?imageView2/0/w/1000"
        );
      } else {
        return require("../../assets/images/organization/org_bg.png");
      }
    },
    handleLiveDuration() {
      let { room_start_time, room_end_time } = this.liveReport;
      // let time = room_end_time - room_start_time;
      // // this.liveReport.liveDuration = duration;
      let {
        hours = 0,
        minutes = 0,
        second = 0,
      } = getDurationByStartEndTime(room_start_time, room_end_time);
      let str = "共计";
      if (hours > 0) {
        str += ` ${hours} 时`;
      }
      str += ` ${minutes} 分 ${second} 秒`;
      return str;
    },
    handleSellTotalAmount() {
      let [integer, decimal] = (this.liveReport.sell_total_amount / 100)
        .toFixed(2)
        .split(".");
      return `<span class="symbol">￥</span><span class="integer">${integer}</span><span class="decimal">.${decimal}</span>`;
    },
    handleSellDuration() {
      let duration = this.liveReport.sell_course_duration;
      const hours = Math.floor(duration / 3600); // 计算小时
      const minutes = Math.floor((duration % 3600) / 60); // 计算分钟
      const second = Math.floor(duration % 60); // 计算秒
      let str = `${minutes < 10 ? "0" + minutes : minutes}:${
        second < 10 ? "0" + second : second
      }`;
      if (hours > 0) {
        str = `${hours}:` + str;
      }
      return str;
    },
  },
  methods: {
    jumpCourseDetail() {
      let { course_id, lesson_id } = this.liveReport;
      let url = `/course-detail/${course_id}?lesson_id=${lesson_id}`;
      if (window.isElectron) {
        this.$router.push(`/learning-center${url}`);
      } else {
        window.open(url);
      }
    },
    apiGetLiveReport() {
      let params = {
        lesson_id: this.$route.params.lesson_id,
      };
      getLiveReport(params).then((res) => {
        if (res.code === 1) {
          this.liveReport = this.handleLiveData(res.data || {});
          this.setOptions();
        } else {
          this.showPageCont = false;
          this.$message.error(res.message);
        }
      });
    },
    handleLiveData(data) {
      // 排序
      data.live_num_statistics_list.sort((a, b) => {
        return a.date - b.date;
      });
      // 一分钟内的-取最后一个数据
      let dataList = [];
      data.live_num_statistics_list.forEach((item) => {
        item.time = moment(item.date * 1000).format("HH:mm");
        let index = dataList.findIndex((dataItem) => {
          return dataItem.time === item.time;
        });
        if (index === -1) {
          dataList.push({ ...item });
        } else {
          dataList[index] = { ...item };
        }
      });
      data.live_num_statistics_list = dataList;
      return data;
    },
    initEcharts() {
      this.myChart = echarts.init(
        document.getElementById("viewers-num-echarts")
      );
      // this.setOptions();
      //   window.addEventListener("resize", this.resize);
    },
    setOptions() {
      var options = {
        tooltip: {
          trigger: "axis",
          borderWidth: 0,
          backgroundColor: "transparent", // 提示框浮层的背景颜色
          borderColor: "transparent",
          padding: 0, // 提示框浮层内边距，单位px
          extraCssText:
            "box-shadow: none;width: 150px;height: 72px;border-radius: 6px;background: linear-gradient( 347deg, #FDFEFF 0%, #F4F7FC 100%);padding: 10px 8px 0 8px;",
          // textStyle: {
          //   width: 300,
          //   height: 900,
          //   lineHeight: 24,
          //   color: "green",
          //   fontSize: "14",
          // },
          formatter: (params) => {
            let param = params[0] || {};
            let [time = "", number = 0] = param?.data || [];
            return `
            <div style="">
                <p style="font-size: 12px;color: #5d6481;line-height: 17px;margin-bottom: 5px;margin-left: 9px;">${time}</p>
                <p style="height: 32px;background: rgba(255, 255, 255, 0.8);border-radius: 4px;display: flex;align-items: center;padding-left: 9px;">
                    <span style="font-size: 12px;color: #5d6481;line-height: 17px;margin-right: 20px;">参与人数</span>
                    <span style=" font-weight: 500; font-size: 12px;color: #0d1400;line-height: 17px;">${number}</span>
                </p>
            </div>`;
          },
        },
        xAxis: {
          type: "time",
          // data: ["20:00", "20:10", "20:20", "20:30", "20:40", "20:50", "21:00"],
          // interval: 3600, // 设置x轴时间间隔
          // data: this.liveReport.live_num_statistics_list.map((item) => {
          //   return moment(item.date * 1000).format("HH:mm:ss");
          // }),
          axisLabel: {
            formatter: {},
            //x轴文字的配置
            show: true,
            textStyle: {
              color: "#5D6481",
            },
            // interval: 5, //主要设置其间隔，间隔为3
          },
          boundaryGap: false,
          axisLine: {
            //x轴线的颜色以及宽度
            show: true,
            lineStyle: {
              color: "#F5F6F9",
            },
          },
          // axisLabel: {

          // },
          splitLine: {
            show: true,
            lineStyle: {
              width: 1,
              color: "rgba(229, 232, 239, 0.40)",
            },
          },
          axisTick: {
            show: false,
          },
          splitNumber: 6,
        },
        yAxis: {
          type: "value",
          splitLine: {
            show: true,
            lineStyle: {
              width: 1,
              type: "dashed",
            },
          },
          axisLine: {
            lineStyle: {
              color: "#5D6481",
            },
          },
        },
        series: [
          {
            // data: [20, 32, 91, 94, 129, 133, 132],
            data: this.liveReport.live_num_statistics_list.map((item) => {
              return [
                moment(item.date * 1000).format("YYYY-MM-DD HH:mm"),
                item.number,
              ];
            }),
            type: "line",
            smooth: true,
            showSymbol: false,
            lineStyle: {
              color: new echarts.graphic.LinearGradient(
                0,
                0,
                1,
                0, // 0, 0, 0, 1 代表右/下/左/上
                [
                  { offset: 0, color: "rgba(30, 231, 255, 1)" },
                  { offset: 0.5, color: "rgba(36, 154, 255, 1)" },
                  { offset: 1, color: "rgba(111, 66, 251, 1)" },
                ]
              ),
            },
            areaStyle: {
              normal: {
                color: new echarts.graphic.LinearGradient(
                  0,
                  0,
                  0,
                  1, // 0, 0, 0, 1 代表右/下/左/上
                  [
                    { offset: 0, color: "rgba(17, 126, 255, 0.16)" },
                    { offset: 1, color: "rgba(17, 128, 255, 0)" },
                  ]
                ),
              },
            },
            symbolSize: 9,
          },
        ],
        grid: {
          x: 60,
          y: 30,
          x2: 35,
          y2: 68,
        },
        axisPointer: {
          type: "line",
          lineStyle: {
            color: "#4080FF", // 线的颜色
            width: 2, // 线的宽度
            type: "dotted", // 线的类型
          },
        },
      };
      this.myChart.setOption(options);
    },
  },
};
</script>

<style lang="scss" scoped>
$page-header-height: 70px;
.live-data-page.electron-live-data-page {
  .page-header {
    top: $nav-height;
    padding: 0;
  }
}
.live-data-page {
  --live-data-page-header-bg: #fff;
  --live-data-page-card-bg: #ffffff;
  --live-data-page-surface-bg: #fafafa;
  --live-data-page-primary: #0d1400;
  --live-data-page-secondary: #515350;
  --live-data-page-divider: #f2f2f5;

  html.dark & {
    --live-data-page-header-bg: var(--mg-bg-card);
    --live-data-page-card-bg: var(--mg-bg-card);
    --live-data-page-surface-bg: var(--mg-bg-surface);
    --live-data-page-primary: var(--mg-text-primary);
    --live-data-page-secondary: var(--mg-text-secondary);
    --live-data-page-divider: var(--mg-border-subtle);
  }

  min-height: 100vh;
  padding-top: $page-header-height;
  .page-header {
    z-index: 9;
    width: 100%;
    position: fixed;
    top: 0;
    height: $page-header-height;
    background: var(--live-data-page-header-bg);
    display: flex;
    align-items: center;
    padding: 0 56px;
    justify-content: center;
    font-weight: 600;
    font-size: 16px;
    color: var(--live-data-page-primary);
    line-height: 22px;
    .back-btn {
      position: absolute;
      left: 56px;
      display: flex;
      align-items: center;
      font-weight: 400;
      font-size: 16px;
      color: var(--live-data-page-secondary);
      line-height: 22px;
      img {
        width: 9px;
        margin-right: 12px;
      }
    }
  }
  .bg-img-wrap {
    position: relative;
    background: #d4f1e1;
    height: 340px;
    .bg-img-bg {
      position: absolute;
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
    .bg-img {
      position: absolute;
      top: 0;
      left: 50%;
      transform: translateX(-50%);
      width: 800px;
      height: 340px;
      object-fit: cover;
    }
  }
  .page-cont {
    position: relative;
    top: -50px;
    width: 800px;
    background: var(--live-data-page-card-bg);
    border-radius: 24px;
    padding: 30px 0;
    margin: 0 auto;
  }
  .lesson-info-wrap {
    padding: 0 40px;
    display: flex;
    justify-content: space-between;
    margin-bottom: 39px;
    .left-wrap {
      flex: 1;
      width: 0;
      .lesson-name {
        font-weight: 600;
        font-size: 20px;
        color: var(--live-data-page-primary);
        line-height: 28px;
        margin-bottom: 6px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      .time {
        font-weight: 400;
        font-size: 16px;
        color: var(--live-data-page-secondary);
        line-height: 22px;
      }
      .duration {
        margin-left: 40px;
        font-weight: 500;
        font-size: 16px;
        color: var(--live-data-page-secondary);
        line-height: 22px;
      }
    }
    .operate-btn {
      margin-left: 20px;
      width: 162px;
      height: 52px;
      border-radius: 12px;
      border: 1px solid rgba(0, 232, 132, 0.2);

      font-weight: 500;
      font-size: 16px;
      line-height: 22px;
      background: linear-gradient(
        41.94400710581127deg,
        $linear-gradient-begin 0%,
        $linear-gradient-end 100%
      );
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
    }
  }
  .live-heat {
    width: 720px;
    height: 157px;
    background: var(--live-data-page-surface-bg);
    border-radius: 18px;
    margin: 0 auto;
    padding: 12px 0 0;
    margin: 0 auto 20px;
    img {
      width: 86px;
      height: 20px;
      margin-bottom: 21px;
      margin-left: 18px;
    }
  }
  .live-income {
    width: 720px;
    min-height: 76px;
    background: var(--live-data-page-surface-bg);
    border-radius: 18px;
    padding: 12px 0 0;
    margin: 0 auto;
    img {
      width: 86px;
      height: 20px;
      margin-left: 18px;
    }
    .tips {
      margin-top: 10px;
      font-weight: 400;
      font-size: 16px;
      color: var(--live-data-page-secondary);
      line-height: 22px;
      padding-left: 22px;
    }
    .data-wrap {
      padding: 30px 0;
    }
  }
  .data-wrap {
    display: flex;
  }
  .data-wrap.small-course-data-wrap {
    display: flex;
    li {
      flex: 1;
      display: flex;
      flex-direction: column;
      align-items: center;
      padding: 0;
    }
  }
  .sell-data-wrap.data-wrap .data {
    height: 56px;
  }
  .data-item {
    padding: 0 0 0 50px;
    position: relative;
    .data.course-name {
      height: 56px;
      font-weight: 600;
      font-size: 20px;
      color: var(--live-data-page-primary);
      line-height: 28px;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
    }
    .data {
      font-weight: bold;
      font-size: 36px;
      color: var(--live-data-page-primary);
      line-height: 42px;
      margin-bottom: 8px;
    }
    ::v-deep .sell-amount {
      padding-top: 14px;
      font-weight: bold;
      color: #f03349;
      .symbol {
        font-weight: 600;
        font-size: 19px;
        line-height: 26px;
      }
      .integer {
        font-size: 36px;
        line-height: 42px;
      }
      .decimal {
        font-size: 24px;
        line-height: 28px;
      }
    }
    .data-name {
      font-weight: 400;
      font-size: 16px;
      color: var(--live-data-page-secondary);
      line-height: 22px;
    }
    &::after {
      position: absolute;
      right: 0;
      top: 3px;
      display: block;
      content: "";
      width: 1px;
      height: 64px;
      background: linear-gradient(
        180deg,
        rgba(244, 244, 247, 0) 0%,
        var(--live-data-page-divider) 14%,
        var(--live-data-page-divider) 89%,
        rgba(229, 230, 235, 0) 100%
      );
    }
    &:last-child::after {
      display: none;
    }
    &.center {
      display: flex;
      flex-direction: column;
      align-items: center;
      padding: 0;
    }
  }

  .echarts-wrap {
    .title {
      margin-left: 40px;
      font-weight: 400;
      font-size: 16px;
      color: var(--live-data-page-primary);
      line-height: 22px;
    }
  }
  #viewers-num-echarts {
    width: 100%;
    height: 310px;
    margin: 0 auto;
  }
}
//app
.live-data-page.app-live-data-page {
  padding-top: 0;
}
</style>
